import {
    lazyCreateOrUpdateOptionsForFeature,
    OwsOptionsFeatureType,
    TranslationOptions,
} from 'owa-outlook-service-options';
import { logUsage } from 'owa-analytics';

export default async function updateTranslationOptions(
    originalOptions: TranslationOptions,
    newOptions: TranslationOptions
) {
    // Log a data point if translation mode changes
    if (originalOptions.translationMode !== newOptions.translationMode) {
        logUsage('InlineTranslationChangeTranslationMode', [], {
            cosmosOnlyData: newOptions.translationMode.toString(),
        });
    }

    // Log a data point if target language changes
    if (originalOptions.targetLanguage !== newOptions.targetLanguage) {
        logUsage('InlineTranslationChangeTargetLanguage', [], {
            cosmosOnlyData: newOptions.targetLanguage ? newOptions.targetLanguage : 'none',
        });
    }

    // Log a data point for every language opted out of
    newOptions.excludedLanguages.forEach(newLanguage => {
        if (!originalOptions.excludedLanguages.includes(newLanguage)) {
            logUsage('InlineTranslationOptOutOfLanguage', [], { cosmosOnlyData: newLanguage });
        }
    });

    // Log a data point for every language with opt out removed
    originalOptions.excludedLanguages.forEach(originalLanguage => {
        if (!newOptions.excludedLanguages.includes(originalLanguage)) {
            logUsage('InlineTranslationRemoveOptOutOfLanguage', [], {
                cosmosOnlyData: originalLanguage,
            });
        }
    });

    await lazyCreateOrUpdateOptionsForFeature.importAndExecute(
        OwsOptionsFeatureType.Translation,
        newOptions
    );
}
